module.exports = __webpack_public_path__ + "img/country.87cd37c6.svg";